import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import clientForms from './clientForms';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import MeasureRow from './measureData/MeasureRow';
import TabPanel from '../../../common/components/TabPanel';
import FormWrapper from '../../../common/components/FormWrapper';
import ListItemField from '../../../common/components/ListItemField';
import measureForm from './measureData/measureForm';
import settingsSelectors from '../../../settings/settingsSelector';
import { loadAdvisors } from '../../../settings/settingsReducer';
import type { AppDispatch } from '../../../store';
import type { Client } from '../../../common/types/client';
import ChildrenList from './childData/ChildrenList';

type Props = {
  clientId: string;
  client: Client;
  updateClient: (client: Client) => void;
  saveClient?: (client: Client) => void;
};

function ClientForm({ clientId, client, updateClient, saveClient }: Props) {
  const dispatch: AppDispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const advisors = useSelector(settingsSelectors.getAdvisors);
  const tabs = clientForms(advisors);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    dispatch(loadAdvisors());
  }, []);

  return (
    <>
      <Box mx={3} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs variant='scrollable' scrollButtons='auto' value={value} onChange={handleChange}>
          {tabs.map((tab) => (
            <Tab key={`${tab.key}_tab`} label={tab.title} />
          ))}
        </Tabs>
      </Box>
      <Stack px={3} pt={1} pb={2} overflow='auto scroll'>
        <Box component='form' noValidate autoComplete='off' maxWidth='650px'>
          {tabs.map((tab, index) => (
            <TabPanel key={`${tab.key}_panel`} value={value} index={index}>
              {tab.forms.map((form) => (
                <FormWrapper key={form.key} form={form} item={client} save={saveClient} update={updateClient} />
              ))}
              {tab.key === 'clientDocuForms' && (
                <ListItemField
                  items={client.measures || []}
                  headline='Beratung'
                  buttonLabel='Notiz'
                  itemForm={measureForm(advisors)}
                  renderItemRow={(item) => <MeasureRow measure={item} />}
                  handleSave={(value) => {
                    if (saveClient !== null && saveClient !== undefined) {
                      saveClient({
                        ...client,
                        measures: value,
                      });
                    }
                  }}
                  handleChange={(value) => {
                    updateClient({
                      ...client,
                      measures: value,
                    });
                  }}
                />
              )}
              {tab.key === 'clientChildrenForms' && <ChildrenList clientId={clientId} />}
            </TabPanel>
          ))}
        </Box>
      </Stack>
    </>
  );
}

export default ClientForm;
